import { Component, Input, OnInit } from '@angular/core';
import { partnerBrandingFor } from '../../models/integration/partner-branding';
import { IntegrationCardView } from '../../models/integration/vendor-definition.model';
import { IPartnerConnection } from '../../models/outbound/partner-connection.model';
import { PartnerConnectionService } from '../../services/partner-connection.service';

/**
 * "Partner-Apps" on Org Settings → Integrations (REV-21656): the guided
 * partners an admin can connect, rendered as universal integration cards.
 * The card carries no actions — connect/disconnect live in the info modal,
 * exactly like every vendor integration.
 */
@Component({
    selector: 'aumico-partner-connect-section',
    templateUrl: './partner-connect-section.component.html',
    styleUrls: ['./partner-connect-section.component.scss'],
})
export class PartnerConnectSectionComponent implements OnInit {
    /** The signed-in admin's email, forwarded as login_hint (never a secret). */
    @Input() public loginHint: string | null = null;

    public connections: IPartnerConnection[] = [];
    public activeConnection: IPartnerConnection | null = null;
    public hasError = false;

    public constructor(private readonly partnerConnectionService: PartnerConnectionService) {}

    public ngOnInit(): void {
        this.reload();
    }

    public trackByClientId(_index: number, connection: IPartnerConnection): string {
        return connection.clientId;
    }

    public cardView(connection: IPartnerConnection): IntegrationCardView {
        const branding = partnerBrandingFor(connection.appKey);
        return {
            vendor: connection.clientId,
            // Verbatim partner name — never an i18next key (see IntegrationCardView).
            displayNameRaw: connection.displayName,
            descriptionKey: branding.descriptionKey ?? 'aumico_partner_connect_card_description',
            logoSrc: branding.logoSrc,
            bannerBgColor: branding.bannerBgColor,
        };
    }

    public onInfo(connection: IPartnerConnection): void {
        this.activeConnection = connection;
    }

    public onModalClosed(): void {
        this.activeConnection = null;
    }

    public onDisconnected(): void {
        this.activeConnection = null;
        this.reload();
    }

    private reload(): void {
        this.partnerConnectionService.list().subscribe({
            next: (connections) => (this.connections = connections),
            error: () => (this.hasError = true),
        });
    }
}
